import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  brandDetail: {},
};

export const brandDetailsSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setBrandName: (state, action) => {
      state.brandDetail = { ...action.payload };
    },
  },
});

export const { setBrandName } = brandDetailsSlice.actions;

const brandDetailsSliceReducer = brandDetailsSlice.reducer;

export default brandDetailsSliceReducer;
